"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statSummary = statSummary;
var _request = _interopRequireDefault(require("@/utils/request"));
// 超级补贴累计统计（累计补贴金额与累计出单笔数，口径为已核销记录）
function statSummary(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/stat',
    method: 'get',
    params: params
  });
}